import React from 'react';
import { EmailBlock, SpacerBlockContent } from '../../types';

interface SpacerPropertiesProps {
  block: EmailBlock;
  onUpdate: (updates: Partial<SpacerBlockContent>) => void;
  mergeTags?: Array<{ name: string; value: string; sample: string }>;
  isDarkMode: boolean;
}

export const SpacerProperties: React.FC<SpacerPropertiesProps> = ({
  block,
  onUpdate,
  isDarkMode
}) => {
  const content = block.content as SpacerBlockContent;

  return (
    <div className="space-y-4">
      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Height (px)
        </label>
        <input
          type="number"
          value={content.height || 20}
          onChange={(e) => onUpdate({ height: parseInt(e.target.value) || 20 })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          min="1"
          max="500"
        />
        <p className={`
          mt-1 text-xs
          ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}
        `}>
          Spacing height in pixels
        </p>
      </div>
    </div>
  );
};
